import {
  FormControl,
  FormControlProps,
  FormLabel,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import * as React from 'react';

import { SelectButton } from '@/components/SelectButton';
import { MembershipTermAlertSearchFilter } from '@/graphql-types/globalTypes';
import { useFeatureFlags } from '@/imports/ui/hooks/useFeatureFlags';

type TermAlertsFilterProps = {
  value: MembershipTermAlertSearchFilter[];
  onChange: (value: MembershipTermAlertSearchFilter[]) => void;
} & Omit<FormControlProps, 'value' | 'onChange'>;

const READABLE_TERM_ALERTS = {
  [MembershipTermAlertSearchFilter.NONE]: 'None',
  [MembershipTermAlertSearchFilter.UP_FOR_RENEWAL]: 'Up for Renewal',
  [MembershipTermAlertSearchFilter.PAYMENT_NEEDED]: 'Payment Needed',
  [MembershipTermAlertSearchFilter.PAST_DUE]: 'Past Due',
  [MembershipTermAlertSearchFilter.RECENTLY_LAPSED]: 'Recently Lapsed',
  [MembershipTermAlertSearchFilter.PAYMENT_FAILED]: 'Payment Failed',
  [MembershipTermAlertSearchFilter.ACH_VERIFICATION_NEEDED]:
    'ACH Verification Needed',
  [MembershipTermAlertSearchFilter.ACH_PROCESSING]: 'ACH Processing',
  [MembershipTermAlertSearchFilter.UNPAID_INVOICE]: 'Unpaid Invoice',
};

export const TermAlertsFilter: React.FC<TermAlertsFilterProps> = ({
  value,
  onChange,
  ...props
}) => {
  const featureFlags = useFeatureFlags();

  return (
    <FormControl {...props}>
      <FormLabel textStyle="detailStrong">Term Status</FormLabel>
      <Menu closeOnSelect={false}>
        <MenuButton as={SelectButton} variant="menu">
          {value.length === 0
            ? 'All'
            : value.length === 1
            ? READABLE_TERM_ALERTS[value[0]]
            : `(${value.length}) Selected`}
        </MenuButton>
        <MenuList>
          <MenuOptionGroup value={value} onChange={onChange} type="checkbox">
            <MenuItemOption value={MembershipTermAlertSearchFilter.NONE}>
              {READABLE_TERM_ALERTS[MembershipTermAlertSearchFilter.NONE]}
            </MenuItemOption>
            <MenuItemOption
              value={MembershipTermAlertSearchFilter.UP_FOR_RENEWAL}
            >
              {
                READABLE_TERM_ALERTS[
                  MembershipTermAlertSearchFilter.UP_FOR_RENEWAL
                ]
              }
            </MenuItemOption>
            <MenuItemOption
              value={MembershipTermAlertSearchFilter.PAYMENT_NEEDED}
            >
              {
                READABLE_TERM_ALERTS[
                  MembershipTermAlertSearchFilter.PAYMENT_NEEDED
                ]
              }
            </MenuItemOption>
            <MenuItemOption value={MembershipTermAlertSearchFilter.PAST_DUE}>
              {READABLE_TERM_ALERTS[MembershipTermAlertSearchFilter.PAST_DUE]}
            </MenuItemOption>
            <MenuItemOption
              value={MembershipTermAlertSearchFilter.RECENTLY_LAPSED}
            >
              {
                READABLE_TERM_ALERTS[
                  MembershipTermAlertSearchFilter.RECENTLY_LAPSED
                ]
              }
            </MenuItemOption>
            <MenuItemOption
              value={MembershipTermAlertSearchFilter.PAYMENT_FAILED}
            >
              {
                READABLE_TERM_ALERTS[
                  MembershipTermAlertSearchFilter.PAYMENT_FAILED
                ]
              }
            </MenuItemOption>
            <MenuItemOption
              value={MembershipTermAlertSearchFilter.ACH_PROCESSING}
            >
              {
                READABLE_TERM_ALERTS[
                  MembershipTermAlertSearchFilter.ACH_PROCESSING
                ]
              }
            </MenuItemOption>
            <MenuItemOption
              value={MembershipTermAlertSearchFilter.ACH_VERIFICATION_NEEDED}
            >
              {
                READABLE_TERM_ALERTS[
                  MembershipTermAlertSearchFilter.ACH_VERIFICATION_NEEDED
                ]
              }
            </MenuItemOption>
            {featureFlags.invoicing && (
              <MenuItemOption
                value={MembershipTermAlertSearchFilter.UNPAID_INVOICE}
              >
                {
                  READABLE_TERM_ALERTS[
                    MembershipTermAlertSearchFilter.UNPAID_INVOICE
                  ]
                }
              </MenuItemOption>
            )}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </FormControl>
  );
};
